import jsonLogic from 'json-logic-js';

const opposingActions = {
  show: 'hide',
  hide: 'show',
  enable: 'disable',
  disable: 'enable',
  clear: 'clear',
  calculated: 'entered',
  entered: 'calculated',
};

export const evaluateJsonLogic = config => {
  // TODO: Would be nice if jsonLogic ignored unknown ops
  // jsonLogic.apply() doesn't want the action key and I'd rather not cloneDeep
  // just for something like that
  const action = config.action;
  delete config.action;

  if (jsonLogic.apply(config)) {
    config.action = action;
    return config.action;
  }

  config.action = action;

  return opposingActions[config.action];
};
